<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<!-- <c-form-item type="input" label="用户名" name="login_name"></c-form-item> -->
					<c-form-item type="input" label="昵称" name="nick_name"></c-form-item>
					<c-form-item type="input" label="手机号" name="user_manage_mobilephone"></c-form-item>
					<c-form-item type="input" label="用户地址"  name="user_address" placeholder=""></c-form-item>
					<c-form-item type="select" label="等级" name="user_level" options="USER_LEVEL_AUTH"></c-form-item>
					<c-form-item type="checkbox" label="用户状态" name="state" :options="stateType" :value="[1]"></c-form-item>
<!--
					<c-form-item type="checkbox" label="授权状态" name="auth_state" :options="authState"></c-form-item>
-->
				</c-form>
			</m-search>
			<m-operate>
				<c-button color="sys" icon="add" power="b_platform_user_edit" @click="editUser()">新增用户</c-button>
				<c-button color="black" power="b_platform_set_user_level"  hollow @click="setUserLevel(1)">设置用户等级</c-button>
				<c-button color="black" power="b_platform_set_salesman"  hollow @click="setUserSalesman(1)">设置业务员</c-button>
                <c-button color="black" power="b_platform_user_export"  @click="exportData()">导出</c-button>

                <c-button color="red" v-if="userInfo.id == 1"  @click="importUser()">导入会员</c-button>
                <c-button color="black" v-if="userInfo.id == 1"  @click="initTempUser()">初始化导入会员</c-button>
                <c-button color="red" v-if="userInfo.id == 1"  @click="initTempUserBranch()">初始化导入会员树</c-button>
                <c-button color="black" v-if="userInfo.id == 1"  @click="resetBranchRef()">重置关系树</c-button>
            </m-operate>
            <c-table ref="table">
<!--				<c-table-column-->
<!--					type="selector"-->
<!--				></c-table-column>-->

				<!-- <c-table-column
					label="用户名"
					name="login_name"
					width="110"
				>
				</c-table-column> -->
	            <c-table-column
		            label="昵称"
		            name="nick_name"
		            width="200"
	            >
		            <template v-slot="{data}">
			            <div class="flex-center-cross">
				            <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"> </c-image>
				            <span v-if="data.nick_name && data.nick_name!=''">{{data.nick_name}}</span>
				            <span v-else>--</span>
			            </div>
		            </template>
	            </c-table-column>

				<c-table-column
						label="手机号"
						name="user_manage_mobilephone"
					  width="120"
				>
					<template v-slot="{data}">
						<span v-if="data.user_manage_mobilephone">
							{{data.user_manage_mobilephone}}
						</span>
						<span v-else>--</span>
					</template>
				</c-table-column>

				<c-table-column
					label="等级"
					name="user_level_name"
				>
					<template v-slot="{data}">
						<span v-if="data.user_level_name && data.user_level_name!='' && data.user_level > -99" style="color:blue">{{data.user_level_name}}</span>
						<span v-else>--</span>
					</template>
				</c-table-column>

				<c-table-column
					label="邀请人"
					name="share_user_phone"
		            width="200"
		        >
					<template v-slot="{data}">
						<span v-if="data.share_user_name">{{data.share_user_name}}</span>
						<span v-if="data.share_user_phone">({{data.share_user_phone}})</span>
					</template>
				</c-table-column>

                <c-table-column
					label="用户地址"
					name="user_address"
                    width="150"
                >
					<template v-slot="{data}">
						<span v-if="data.user_address && data.user_address!=''">{{data.user_address}}</span>
						<span v-else>--</span>
					</template>
				</c-table-column>

				<c-table-column
					label="下单数"
					name="order_count"
					width="60"
				>
				</c-table-column>

				<c-table-column
					label="退款单数"
					name="refund_count"
					width="80"
				>
				</c-table-column>

				<c-table-column
					label="用户ID"
					name="platform_user_id"
				>
				</c-table-column>

				<c-table-column
					label="注册时间"
					name="create_date"
					width="140"
				>
				</c-table-column>

				<c-table-column
					label="注册来源"
					name="user_resource"
					width="100"
				>
					<template v-slot="{data}">
						{{userResourceMap[data.user_resource]}}
					</template>
				</c-table-column>

				<c-table-column
					label="状态"
					name="state"
					width="50"
				>
					<template v-slot="{data}">
						<span v-if="data.state == 1" style="color:darkgreen">启用</span>
						<span v-if="data.state == 2" style="color:red">禁用</span>
					</template>
				</c-table-column>

				<c-table-column
					label="店铺开通状态"
					name="shop_id"
					width="100"
					v-if="systemConfig.oms_seller_shop_enabled == 'ON'"
				>
					<template v-slot="{data}">
						<span v-if="data.shop_id == 0" style="color:#bbb">未开通</span>
						<span v-else style="color:darkgreen">已开通</span>
					</template>
				</c-table-column>

				<c-table-column
					label="实名认证"
					name="auth_state"
					width="80"
					v-if="systemConfig.f_config_user_auth_enabled =='ON'"
				>
					<template v-slot="{data}">
						<span v-if="data.auth_state == -1" style="color:#bbb">未认证</span>
						<span v-if="data.auth_state == 0" style="color:blue">审核中</span>
						<span v-if="data.auth_state == 1" style="color:darkgreen">认证通过</span>
						<span v-if="data.auth_state == 2" style="color:red">认证驳回</span>
					</template>
				</c-table-column>

				<!-- <c-table-column
					label="账户余额(元)"
					name="account_balance"
					width="100"
					v-if="systemConfig.account_balance_enabled == 'ON'"
				>
					<template v-slot="{data}">
						￥{{data.account_balance}}
					</template>
				</c-table-column> -->

				<c-table-column
					label="授信额度(元)"
					name="credit_money"
					width="100"
					v-if="systemConfig.credit_pay == 'ON'"
				>
					<template v-slot="{data}">
						<span v-if="data.credit_money > 0">
							￥{{data.credit_money}}
						</span>
						<span v-else>--</span>
					</template>
				</c-table-column>
				<c-table-column
					label="授信余额(元)"
					name="credit_money"
					width="100"
					v-if="systemConfig.credit_pay == 'ON'"
				>
					<template v-slot="{data}">
						<span v-if="data.credit_money > 0">
							￥{{data.credit_money - data.credit_money_use}}
						</span>
						<span v-else>--</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="最近登陆时间"
					name="last_login_date"
					width="140"
				>
				</c-table-column>

				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="200"
				>
					<template v-slot="{data}">
						<c-table-button power="b_platform_user_detail" @click="detail(data)">详情</c-table-button>
                        <c-table-button power="b_user_edit_info" @click="setBaseInfo(data)">修改资料</c-table-button>
						<c-table-button power="b_platform_user_state" v-if="data.platform_user_id > 0 && data.state == 2"  @click="updateState(1,data)">启用</c-table-button>
						<c-table-button power="b_platform_user_state" v-if="data.platform_user_id > 0 && data.state == 1"  @click="updateState(2,data)">禁用</c-table-button>
						<c-table-button power="b_platform_user_shop" v-if="data.platform_user_id > 0 &&data.shop_id == 0" @click="openShop(data)">开通店铺</c-table-button>
		                <c-table-button power="b_member_user_change" v-if="data.platform_user_id > 0" @click="setMember(data)">会员调整</c-table-button>
                        <c-table-button power="b_member_user_change" @click="viewUpgradeRecord(data)">调整日志 </c-table-button>
                    </template>
				</c-table-column>
			</c-table>
			<c-dialog ref="editUserDialog" :title="editState ? '编辑用户' : '新增用户'" width="750" @resolve="submitEditUser">
				<c-form ref="edit_form">
					<c-form-item type="hidden" name="id"></c-form-item>
					<c-form-item type="number" decimal="0"  label="手机号" maxlength="11" name="mobile_phone" required word="请输入11位手机号"></c-form-item>
					<!-- <c-form-item type="input" label="用户名" name="login_name" maxlength="16" word="用于登录平台，登录名只允许包含中文、英文字母、数字、下划线，长度在1-16位"></c-form-item> -->
					<c-form-item type="input" label="昵称" name="nick_name" maxlength="30" word="不设置将由系统自动生成，昵称只允许输入中文、英文最大长度为30个字符"></c-form-item>
				</c-form>
			</c-dialog>

			<c-dialog ref="levelEdit" title="设置用户等级" width="500" height="250" @resolve="setLevelHandle">
				<div class="tag-list" style="padding: 20px;">
					<c-radio-group v-model="current_user_level">
						<c-radio v-for="(item, i) in user_level_list" :key="i" :value="item.value" style="margin-bottom: 20px;">{{item.name}}</c-radio>
					</c-radio-group>
				</div>
			</c-dialog>

			<c-dialog ref="salesmanEdit" title="设置业务员" width="500" height="250" @resolve="setSalesmanHandle">
				<div class="tag-list" style="padding: 20px;">
					<c-radio-group v-model="current_salesman">
						<c-radio v-for="(item, i) in salesman_list" :key="i" :value="item.value" style="margin-bottom: 20px;">{{item.name}}</c-radio>
					</c-radio-group>
				</div>
			</c-dialog>
	  
			<c-dialog ref="shopEdit" title="开通分销商店铺" width="600" @resolve="submitShop">
				<c-form ref="shopForm">
					<c-form title="基本信息">
						<c-form-item type="input" label="经销商名称" name="company_name" maxlength="30" required></c-form-item>
						<c-form-item type="input" label="店铺名称" name="shop_name" maxlength="50" required></c-form-item>
						<c-form-item type="hidden" name="platform_user_id"></c-form-item>
					</c-form>
					<c-form title="配置信息">
						<c-form-item type="region" label="默认发货地" province-name="delivery_province_id" city-name="delivery_city_id"  required></c-form-item>
						<c-form-item type="select" label="分销商角色" name="auth_id" options="SELLER_AUTH" required></c-form-item>
						<c-form-item type="radio" label="清分方式" name="liquidation_type" :options="liquidationType" required></c-form-item>
						<c-form-item type="number" label="" name="liquidation_date" :limit="[0,100]" word="天"></c-form-item>
					</c-form>
				</c-form>
			</c-dialog>

          <c-dialog ref="memberDialog" title="调整会员邀请人/等级" width="600" @resolve="setMemberHandle">
            <c-form ref="memberForm">
              <c-form title="会员信息" title-margin="10">
                <c-form-item type="input" label="会员昵称:" name="nick_name" disabled> </c-form-item>
                <c-form-item type="input" label="会员手机号:" name="user_manage_mobilephone" disabled> </c-form-item>
              </c-form>
              <c-form title="邀请人" title-margin="10">
                <c-form-item type="input" label="当前邀请人:" name="share_user_name" disabled> </c-form-item>
                <c-form-item type="hidden" name="share_user_id"></c-form-item>
                <c-form-item type="input" @click="$refs.memberUserSelector.open()" readonly label="修改为:" name="tran_share_user_name" required word="调整后该用户后续带来的奖励奖归于新的邀请人下">
                </c-form-item>
              </c-form>
              <c-form title="会员等级" title-margin="10">
                <c-form-item type="input" label="当前等级:" name="user_level_name" disabled></c-form-item>
                <c-form-item type="select" label="调整为:" name="user_level" options="USER_LEVEL_AUTH" required></c-form-item>
              </c-form>
            </c-form>
          </c-dialog>
          <!--编辑用户资料信息-->
          <c-dialog ref="baseInfoDialog" title="编辑用户资料" width="600" @resolve="setBaseInfoHandle">
                <c-form ref="baseInfoForm">
                    <c-form-item type="input" label="授权代码:" name="login_name" required> </c-form-item>
                    <c-form-item type="input" label="手机号码:" name="user_manage_mobilephone" required> </c-form-item>
                    <c-form-item type="input" label="昵称:" name="nick_name" required> </c-form-item>
                    <c-form-item type="region" label="地址"
                                 province-name="province_id"
                                 city-name="city_id"
                                 county-name="county_id"
                    ></c-form-item>
                    <c-form-item type="input" label="地址详情" name="address_detail"></c-form-item>
                    <c-form-item type="textarea" v-model="analysis_text"  placeholder="请填入收件人姓名、电话、地址信息，系统将自动识别"></c-form-item>
                    <m-operate style="position: absolute;right: 0;">
                        <c-button color="red" @click="analysisAddress()" style="margin-right:16px;margin-top:-50px">智能识别</c-button>
                    </m-operate>
                </c-form>
            </c-dialog>
          <!--编辑用户资料信息-->
          <c-dialog ref="upgradeRecordDialog" title="会员调整日志" width="1200" height="800" enable-flex :button="false">
                <c-table ref="upgradeRecordTable" height="grow">
                    <c-table-column label="调整类型" width="100" name="reward_type">
                        <template v-slot="{data}">
                            <span v-if="data.upgrade_type==1">用户注册</span>
                            <span v-if="data.upgrade_type==2">总后台变更</span>
                            <span v-if="data.upgrade_type==3">购买会员升级</span>
                            <span v-if="data.upgrade_type==6">上级经销商调整</span>
                            <span v-if="data.upgrade_type==7">邀请保护期过期</span>
                        </template>
                    </c-table-column>
                    <c-table-column label="调整前等级" name="pre_level_name" width="90"></c-table-column>
                    <c-table-column label="调整后等级" name="upgrade_level_name" width="90"></c-table-column>
                    <c-table-column label="调整前分享人" width="160">
                        <template v-slot="{data}">
                            <div class="flex-center-cross">
                                <c-image :src="data.pre_share_user_head_photo" preview size="30" style="margin-right: 10px;"> </c-image>
                                <span v-if="data.pre_share_user_nick_name && data.pre_share_user_nick_name!=''">{{data.pre_share_user_nick_name}}</span>
                                <span v-else>--</span>
                                <span v-if="data.pre_share_user_phone">{{data.pre_share_user_phone}}</span>
                            </div>
                        </template>
                    </c-table-column>
                    <c-table-column label="调整后分享人" width="160">
                        <template v-slot="{data}">
                            <div class="flex-center-cross">
                                <c-image :src="data.upgrade_share_user_head_photo" preview size="30" style="margin-right: 10px;"> </c-image>
                                <span v-if="data.upgrade_share_user_nick_name && data.upgrade_share_user_nick_name!=''">{{data.upgrade_share_user_nick_name}}</span>
                                <span v-else>--</span>
                                <span v-if="data.upgrade_share_user_phone">{{data.upgrade_share_user_phone}}</span>
                            </div>
                        </template>
                    </c-table-column>
                    <c-table-column label="调整处理人" width="160">
                        <template v-slot="{data}">
                            <div class="flex-center-cross" v-if="data.upgrade_type==2 || data.upgrade_type==6">
                                <c-image v-if="data.create_user_head_photo" :src="data.create_user_head_photo" preview size="30" style="margin-right: 10px;"> </c-image>
                                <span v-if="data.create_user_name && data.create_user_name!=''">{{data.create_user_name}}</span>
                                <span v-else>--</span>
                                <span v-if="data.create_user_phone">{{data.create_user_phone}}</span>
                            </div>
                            <div v-else>--</div>
                        </template>
                    </c-table-column>
                    <c-table-column label="调整时间" name="create_date" width="155"></c-table-column>
                </c-table>
            </c-dialog>
          <member-user-selector ref="memberUserSelector" @resolve="selectHandle($event, 'memberList', 'platform_user_id')"></member-user-selector>
        </module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
  import memberUserSelector from "@/components/service/member_user_selector.vue";

  export default {
		name: 'm_platform_user',
    components: {memberUserSelector},

		data() {
			return {
				editState: false,   //编辑或是新增  true=编辑  false=新增
				userResourceMap: {
                      'OMS':'管理后台',
                      'PC':'PC电脑',
                      'IOS':'苹果APP',
                      'ANDROID':'安卓APP',
                      'MINI':'微信小程序',
                      'BARGAIN':'砍价页',
                      'H5':'H5页'
				},
				stateType:[
					{name:'启用', value:1},
					{name:'禁用', value:2},
				],
				authState:[
					{name:'已授权', value:1},
					{name:'未授权', value:2},
				],
				liquidationType:[
				  {
				    name:'发货后',
				    value:1
				  }, {
				      name:'确认收货后',
				      value:2
				  }
				],
				current_user_level:-99,//当前选中的等级
				user_level_list:[],//用户等级列表
				current_salesman:'',//当前选中的业务员
				salesman_list:[],//业务员列表
                analysis_text:''
            }
		},
		computed: {
            ...mapState(['userInfo', 'systemConfig']),
		},
		mounted() {
			this.$refs.search.search();
		},

		methods: {
            selectHandle(list, ref, key) {
            var tran_share_user_name = "--";
            var share_user_id = -1;
            if (list && list[0]){
              tran_share_user_name = (list[0].nick_name || "--") + "【" + (list[0].user_manage_mobilephone||"--") + "】";
              share_user_id = list[0].platform_user_id||-1;
            }
            this.$refs.memberForm.set({
              tran_share_user_name: tran_share_user_name,
              share_user_id: share_user_id,
            });
          },
            searchHandle(data) {
                data.query_type = 1;
                this.$refs.table.load({
                    url: '/platform_user/list',
                    data
                });
                this.searchDate = data;
            },
            detail(val) {
                    this.navigateTo({
                        path: '/member/'+val.platform_user_id,
                    });
            },
            //会员资料编辑（弹框）
            setBaseInfo(data){
                this._setUserIds = data.platform_user_id;
                this.$refs.baseInfoForm.clear();
                this.$refs.baseInfoForm.set(data);
                this.$refs.baseInfoDialog.open();
            },

            //会员资料编辑（提交）
            setBaseInfoHandle(stop) {
                stop();
                this.$refs.baseInfoForm.submit({
                    url: '/member_user/edit_user_info',
                    rule: {
                        login_name: '请输入会员授权代码',
                        user_manage_mobilephone: '请输入会员手机号码',
                        nick_name: '请输入会员昵称'
                    },
                    dataFormatter: data => {
                        data.member_user_id = this._setUserIds;
                        return data;
                    },

                    success: data => {
                        this.$refs.baseInfoDialog.close();
                        this.$message({
                            text: '会员资料编辑成功!'
                        });
                        this.$refs.table.update();
                    }
                })
            },
            //地址智能识别
            analysisAddress() {
                if (!this.analysis_text || this.analysis_text.length == 0){
                    this.$message({
                        text: '请输入需要识别的内容',
                        icon: 'fail'
                    });
                    return false;
                }
                this.request({
                    url: '/platform_user/address/analysis',
                    data: {
                        text: this.analysis_text
                    },
                    loading: true,
                    timeout: false,
                    success: (data, message) => {

                        data.nick_name = data.receiving_name;
                        data.user_manage_mobilephone = data.receiving_phone;

                        data.province_id = data.receiving_address_province_id;
                        data.city_id = data.receiving_address_city_id;
                        data.county_id = data.receiving_address_county_id;
                        data.address_detail = data.receiving_address_details;
                        this.$refs.baseInfoForm.set(data);
                        this.$message({
                            text: '智能识别成功',
                            icon: 'success'
                        });
                    }
                });
            },
            updateState(type,val) {
                    this.$confirm({
                        text: '确定要'+(type==1?'启用':'禁用')+'【'+val.user_manage_mobilephone+'】吗？',  // 提示内容,
                        buttonName: '确定',  // 确定按钮文字
                        cancelButton: true,  // 是否显示取消按钮
                        resolve: () => {
                            this.request({
                                url: '/platform_user/update_state',
                                data: {platform_user_id:val.platform_user_id,state:type},
                                loading: true,
                                success: data => {
                                    this.$message({
                                        text: '操作成功',
                                        icon: 'success'
                                    });
                                    this.$refs.table.update();
                                }
                            });
                        },  // 确定按钮回调
                        cancel: () => {},  // 取消按钮回调
                    });
                },
            /**打开 新增/编辑 弹窗**/
            editUser(){
              //清空表单数据
              this.$refs.edit_form.clear();
              this.editState = false;//新增
              this.$refs.editUserDialog.open();
              this.$refs.edit_form.set({});
          },
            /**提交修改**/
            submitEditUser(stop){
            stop();
            this.$refs.edit_form.submit({
              url: '/platform_user/add',
              rule: {
                mobile_phone: '请输入用户手机号'
              },
              success: (data, res) => {
                  //关闭弹窗
                  this.$refs.editUserDialog.close();
                  this.$message({
                      text:'操作成功！'
                  });
                  // 清空表单数据
                  this.$refs.edit_form.clear();
                  this.$refs.search.search();
              }
            });
          },
            /***批量修改用户等级**/
            setUserLevel(batch,item) {
            this.userIds = [];
            if(batch == 1){//批量设置
                var list = this.$refs.table.getRow('selected');
                if (!list.length) {
                  this.$message({
                    text: '请选择要操作的用户'
                  });
                  return;
                }
                this.userIds = Array.from(list,item=>{
                  return item.data.platform_user_id;
                })
            }else{//单个设置
                this.userIds.push(item.platform_user_id);
            }
            this.request({
              url: '/user_level/options',
              data: {},
              loading: true,
              success: data => {
                this.user_level_list = data;
                this.$nextTick(() => {
                    this.current_user_level = -99;
                });
                this.$refs.levelEdit.open();
              }
            });
          },
            //设置用户等级
            setLevelHandle(stop) {
            stop();
            if (this.current_user_level==-99) {
              this.$message({
                text: '请选择用户等级'
              });
              return;
            }
            this.request({
              url: '/platform_user/set_level',
              data: {
                user_ids: this.userIds,
                user_level: this.current_user_level
              },
              loading: true,
              success: data => {
                  this.$message({
                    text: '设置用户等级请求发送成功，调整结果可能稍有延迟！'
                  });
                  this.$refs.levelEdit.close();
                  //延迟刷新页面
                setTimeout(() => {
                    this.$refs.table.update();
                  }, 1000);
              }
            });
          },
            /***批量修改用户业务员**/
            setUserSalesman(batch,item) {
            this.userIds = [];
            if(batch == 1){//批量设置
                var list = this.$refs.table.getRow('selected');
                if (!list.length) {
                  this.$message({
                    text: '请选择要操作的用户'
                  });
                  return;
                }
                this.userIds = Array.from(list,item=>{
                  return item.data.platform_user_id;
                })
            }else{//单个设置
                this.userIds.push(item.platform_user_id);
            }
            this.request({
              url: '/sys_user/options',
              data: {},
              loading: true,
              success: data => {
                this.salesman_list = data;
                this.$nextTick(() => {
                  this.current_salesman = '';
                });
                this.$refs.salesmanEdit.open();
              }
            });
          },
            //设置用户业务员
            setSalesmanHandle(stop) {
            stop();
            if (!this.current_salesman) {
              this.$message({
                text: '请选择业务员'
              });
              return;
            }
            this.request({
              url: '/platform_user/set_salesman',
              data: {
                user_ids: this.userIds,
                salesman_id: this.current_salesman
              },
              loading: true,
              success: data => {
                this.$message({
                  text: '设置业务员成功'
                });
                this.$refs.salesmanEdit.close();
                //刷新页面
                this.$refs.table.update();
              }
            });
          },
            //开通店铺
            openShop(val){
            this.$refs.shopForm.clear();
            val.company_name = val.nick_name;
            val.shop_name = val.nick_name+'的小店';
            this.$refs.shopForm.set(val);
            this.$refs.shopEdit.open();
          },
            submitShop(stop) {
            stop();
            this.$refs.shopForm.submit({
              url: '/platform_user/openShop',
              rule: {
                company_name: '请输入经销商名称',
                shop_name: '请填写店铺名称',
                delivery_city_id : '请选择发货地',
                auth_id: '请选择分销商家角色',
                liquidation_type: '请选择清分方式',
                liquidation_date: '请输入清分延迟天数'
              },
              dataFormatter: data => {
                return data;
              },
              success: (data, res, msg) => {
                this.$confirm({
                  icon: 'success',
                  text: msg,  // 提示内容,
                  buttonName: '确定',  // 确定按钮文字
                  cancelButton: false  // 是否显示取消按钮
                });
                this.$refs.table.update();
                this.$refs.shopEdit.close();
              }
            });
          },
            //调整会员等级
            setMember(data) {
                this.$refs.memberForm.clear();
                this._edit = data;
                this.$refs.memberForm.set({
                  share_user_name: (data.share_user_name || "") + "【" + (data.share_user_phone||'--') + "】",
                  tran_share_user_name: (data.share_user_name || "") + "【" + (data.share_user_phone||'--') + "】",
                  user_level_name: data.user_level_name||'普通用户',
                  share_user_id: data.share_user_id,
				  user_level: data.user_level,
                  nick_name: data.nick_name,
                  user_manage_mobilephone: data.user_manage_mobilephone
                });
                this.$refs.memberDialog.open();
              },
            //保存调整会员等级
            setMemberHandle(stop) {
            stop();
            this.$refs.memberForm.submit({
              url: '/member_user/adjustment',
              rule: {
                share_user_id: '请设置邀请人',
				user_level: '请设置等级',
              },
              dataFormatter: data => {
                data.member_user_id = this._edit.platform_user_id;
                delete data.tran_share_user_name;
                return data;
              },

              success: data => {
                this.$refs.memberDialog.close();
                this.$message({
                  text: '请求发送成功，调整结果可能稍有延迟!'
                });
                //延迟500ms刷新页面
                setTimeout(() => {
                  this.$refs.table.update();
                }, 1000);
              }
            })
          },
            /**********重置关系树**************/
            resetBranchRef() {
                this.$confirm({
                    text: '重置关系树将根据会员表中的邀请人重新生成邀请关系树，是否确认重置？',
                    buttonName: '确认重置',
                    resolve: () => {
                        this.request({
                            url: '/platform_user//init/branch',
                            data: {},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '重置成功'
                                });
                                this.$refs.table.update();
                            }
                        });
                    }
                });
            },
            //批量导出订单
            exportData() {
                var data = this.searchDate;
                data.job_id = 42;
                this.request({
                    url: '/export_job/add',
                    data: data,
                    loading: true,
                    success: data => {
                        this.$message({
                            text: '导出任务提交成功，请稍后前往任务中心查看'
                        });
                    }
                });
            },
            //导入用户
            importUser() {
                this.$confirm({
                    title: '导入会员',
                    buttonName: '开始导入',  // 确定按钮文字
                    text: '请使用标准模板进行导入发货 <a href="https://guimi-2025.oss-cn-hangzhou.aliyuncs.com/app_static/%E4%BC%9A%E5%91%98%E5%8F%8A%E9%82%80%E8%AF%B7%E5%85%B3%E7%B3%BB%E6%95%B0%E6%8D%AE%E6%A8%A1%E6%9D%BF.xlsx" target="_blank" style="color:dodgerblue;">模板下载</a>',
                    resolve: () => {
                        this.uploadFile({
                            message: false,
                            success: data => {
                                this.request({
                                    url: '/platform_user/import/data',
                                    data: {
                                        filePath: data.filePath
                                    },
                                    loading: true,
                                    timeout: false,
                                    success: (data, message) => {
                                        this.$refs.table.update();
                                        this.$confirm({
                                            title: '执行结果',
                                            text: message,  // 提示内容,
                                            buttonName: '确定',  // 确定按钮文字
                                            icon: 'success',
                                            cancelButton: false  // 是否显示取消按钮
                                        });
                                    }
                                });
                            }
                        })
                    }
                });
            },
            //初始化导入会员
            initTempUser() {
                this.$confirm({
                    text: '请确认是否已经完成会员基础数据的导入？',
                    buttonName: '确认初始化',
                    resolve: () => {
                        this.request({
                            url: '/platform_user/init/user/data',
                            data: {},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '初始化成功'
                                });
                                this.$refs.table.update();
                            }
                        });
                    }
                });
            },
            initTempUserBranch() {
                this.$confirm({
                    text: '请确认是否已经完成会员树数据的导入？',
                    buttonName: '确认初始化',
                    resolve: () => {
                        this.request({
                            url: '/platform_user/init/branch/data',
                            data: {},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '初始化成功'
                                });
                                this.$refs.table.update();
                            }
                        });
                    }
                });
            },
            //查询会员调整日志
            viewUpgradeRecord(val) {
                this.$refs.upgradeRecordDialog.open();
                this.member_user_id = val.platform_user_id;
                this.$refs.upgradeRecordTable.load({
                    url: '/member_user/upgrade/record/list',
                    data: {
                        member_user_id: val.platform_user_id,
                    }
                });
            }
        }
	}
</script>